import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { BarChartConfig } from '../../models/bar-chart-config.model';

@Component({
    selector: 'big-ui-bar-chart',
    templateUrl: './bar-chart.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class BarChartComponent {
    public readonly config = input.required<BarChartConfig>();

    @HostBinding('class') public class = 'block';

    public getDividerStyle(percentage: number): string {
        return `left: ${percentage}%`;
    }

    public getBarStyle(percentage: number): string {
        return `width: ${percentage}%`;
    }
}
